<template>
   <div class="intervention-plan">
    <div class="graph-names">
      <h2>Area: Improvement Level, Due Dates, IEP Intake and Exits</h2>

      <div class="graph-list">
        <div
          v-for="graph in graphNames"
          :key="graph.title"
          class="graph-item"
        >
          <span>{{ graph.title }}</span>

          <div class="graph-buttons">
            <button @click="selectedGraph = graph.title">
              View
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                <line x1="2" y1="13" x2="13" y2="13" style="stroke:white;stroke-width:1" />
                <line x1="2" y1="13" x2="2" y2="2" style="stroke:white;stroke-width:1" />
                <line x1="2" y1="2" x2="6" y2="2" style="stroke:white;stroke-width:1" />
                <line x1="13" y1="13" x2="13" y2="8" style="stroke:white;stroke-width:1" />

                <line x1="14" y1="1" x2="8" y2="6" style="stroke:white;stroke-width:1" />
                <line x1="10" y1="1" x2="14" y2="1" style="stroke:white;stroke-width:1" />
                <line x1="14" y1="1" x2="14" y2="5" style="stroke:white;stroke-width:1" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="the-graph">
      <h2>{{ selectedGraph }}</h2>
      <BarChartECharts2
        :data-input="[
          {
            variable: 'Run',
            value: 1
          }
        ]"
        :bar-colors="['#f6a620']"
      />
      <div class="calibrate-row">
        <div class="date-group">
          <label>Start Date</label>
          <input
            type="date"
            v-model="startDate"
          />
        </div>
        <div class="date-group">
          <label>End Date</label>
          <input
            type="date"
            v-model="endDate"
          />
        </div>
        <button @click="applyDateFilter">
          Calibrate
        </button>
      </div>
      <div class="under-calibrate-row">
        <div class="age-range">
          <label>Age Range</label>
            <select v-model="ageStart">
              <option value=""></option>
              <option value="0">0 yrs</option>
              <option value="1">1 yrs</option>
              <option value="2">2 yrs</option>
              <option value="3">3 yrs</option>
              <option value="4">4 yrs</option>
              <option value="5">5 yrs</option>
              <option value="6">6 yrs</option>
              <option value="7">7 yrs</option>
              <option value="8">8 yrs</option>
              <option value="9">9 yrs</option>
              <option value="10">10 yrs</option>
              <option value="11">11 yrs</option>
              <option value="12">12 yrs</option>
              <option value="13">13 yrs</option>
              <option value="14">14 yrs</option>
              <option value="15">15 yrs</option>
              <option value="16">16 yrs</option>
              <option value="17">17 yrs</option>
              <option value="18">18 yrs</option>
            </select>
          </div>
        <span>-</span>
        <div class="age-range">
            <select v-model="ageEnd">
              <option value=""></option>
              <option value="0">0 yrs</option>
              <option value="1">1 yrs</option>
              <option value="2">2 yrs</option>
              <option value="3">3 yrs</option>
              <option value="4">4 yrs</option>
              <option value="5">5 yrs</option>
              <option value="6">6 yrs</option>
              <option value="7">7 yrs</option>
              <option value="8">8 yrs</option>
              <option value="9">9 yrs</option>
              <option value="10">10 yrs</option>
              <option value="11">11 yrs</option>
              <option value="12">12 yrs</option>
              <option value="13">13 yrs</option>
              <option value="14">14 yrs</option>
              <option value="15">15 yrs</option>
              <option value="16">16 yrs</option>
              <option value="17">17 yrs</option>
              <option value="18">18 yrs</option>
            </select>
          </div>
        <div class="sort-by">
          <label>Area</label>
            <select v-model="area">
              <option value=""></option>
              <option value="Cognitive">Cognitive</option>
              <option value="Motor">Motor</option>
              <option value="Speech and Language">Speech and Language</option>
              <option value="Reading and Writing">Reading and Writing</option>
              <option value="Mental Health">Mental Health</option>
              <option value="Other">Other</option>
            </select>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChartECharts2 from './subComponents/BarChartECharts2.vue';

export default {
  name: 'OrganizationSchoolsGraphs',

  components: {
    BarChartECharts2,
  },
  data() {
  return {
    startDate: '',
    endDate: '',

    selectedGraph: "Number of IEP Intakes at different Case loads",

    graphNames: [
    {
      title: "Number of IEP Intakes at different Case loads",
      graph: null
    },
    {
      title: "Number of IEP Intakes at different Clinical to Client Ratios",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Age",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Ethnicity",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Gender",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Native Language",
      graph: null
    },
    {
      title: "Progress level by Grade",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Class/Home room",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Location/Site",
      graph: null
    },
    {
      title: "Number of IEP Intakes during Selected Days/Weeks/Months/Years",
      graph: null
    },
    {
      title: "Number of Caretakers/Assistants per IEP Intake",
      graph: null
    },
    {
      title: "Number of Teachers per IEP Intake",
      graph: null
    },
    {
      title: "Number of IEP Intakes per Clinician",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Conditions/Diagnosis Types",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Conditions/Diagnosis Levels/Severities",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Comorbidity Types",
      graph: null
    },
    {
      title: "Number of IEP Intakes by Comorbidity Levels/Severities",
      graph: null
    },
    {
      title: "Number of IEP Intakes per Screening method/tool",
      graph: null
    },
    {
      title: "Number of IEP Intakes per Assessment method/tool",
      graph: null
    },
    {
      title: "Number of IEP Intakes per Intervention method/tool",
      graph: null
    },
    {
      title: "Progress level at different Case loads",
      graph: null
    },
    {
      title: "Progress level at different Clinician to Client Ratios",
      graph: null
    },
    {
      title: "Progress level by Age",
      graph: null
    },
    {
      title: "Progress level by Ethnicity",
      graph: null
    },
    {
      title: "Progress level by Gender",
      graph: null
    },
    {
      title: "Progress level by Native Language",
      graph: null
    },
    {
      title: "Progress level by Grade",
      graph: null
    },
    {
      title: "Progress level by Class/Home room",
      graph: null
    },
    {
      title: "Progress level by Location/Site",
      graph: null
    },
    {
      title: "Progress level during Selected Days/Weeks/Months/Years",
      graph: null
    },
    {
      title: "Progress level by Category of questions/tasks",
      graph: null
    },
    {
      title: "Progress level by Caretakers/Assistants (Not in the U.S.)",
      graph: null
    },
    {
      title: "Progress level by Teacher (Not in the U.S.)",
      graph: null
    },
    {
      title: "Progress level by Clinician",
      graph: null
    },
    {
      title: "Progress level by Conditions/Diagnosis Types",
      graph: null
    },
    {
      title: "Progress level by Conditions/Diagnosis Levels/Severities",
      graph: null
    },
    {
      title: "Progress level by Comorbidity Types",
      graph: null
    }
  ]
  }
},
methods:{
  applyDateFilter() {
    console.log(this.startDate);
    console.log(this.endDate);

    // Later:
    // fetch graph with dates
  }
}
};
</script>

<style scoped>
.intervention-plan {
  display: flex;
  gap: 40px;
  align-items: flex-start;
  padding: 40px 60px;
  color: black;
  font-size: 20px;
}

.graph-names {
  flex: 1;
  margin-top:80px;
  margin-right: 130px;
}


.the-graph {
  position: sticky;
  top: 120px;

  margin-left: -100px;
  width: 500px;
  min-width: 500px;
  height: 550px;

  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 12px;

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

  padding: 15px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.the-graph h2{
  font-size: 20px;
}
.graph-item {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 12px 0;

  border-bottom: 1px solid #eee;
}

.graph-buttons {
  display: flex;
  gap: 10px;
}

.graph-buttons button {
  padding: 6px 12px;

  border: none;
  border-radius: 6px;

  cursor: pointer;

  background: #f6a620;
  color: white;
}

.graph-buttons button:hover {
  opacity: 0.9;
}
.calibrate-row {
  display: flex;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 12px;
}

.date-group {
  display: flex;
  flex-direction: column;
}

.date-group label {
  font-size: 16px;
  margin-bottom: 6px;
  font-weight: bold;
}

.date-group input {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 16px;
}

.calibrate-row button {
  padding: 9px 16px;
  border: none;
  border-radius: 6px;
  background: #f6a620;
  color: white;
  cursor: pointer;
}
.under-calibrate-row{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}
.under-calibrate-row span {
  white-space: nowrap;
}
.under-calibrate-row input {
  width: 82px;
}
.sort-by {
  display: flex;
  flex-direction: column;
}

.sort-by label {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
}

.sort-by select {
  width: 250px;
  padding: 8px 12px;

  border: 1px solid #d9d9d9;
  border-radius: 6px;

  font-size: 16px;
  background: white;
}
.age-range {
  display: flex;
  flex-direction: column;
}

.age-range label {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
}

.age-range select {
  width: 80px;
  padding: 8px 12px;

  border: 1px solid #d9d9d9;
  border-radius: 6px;

  gap:2px;

  font-size: 16px;
  background: white;
}
</style>